import React from 'react';
import PropTypes from 'prop-types';
import Accordion from 'react-bootstrap/Accordion';
import FadeIn from 'react-fade-in';

import './styles.scss';

function EPGProgramList({
  emptyComponent = () => <p>NO RESULTS</p>,
  epgItemCollection = [],
  isLoading = false,
  listHeight,
  loadingComponent,
  renderItem
}) {

  return (
    <Accordion
      className="epg-programlist"
      style={listHeight && { height: `${listHeight}px` }}
    >
    {
      isLoading ? loadingComponent :
      (epgItemCollection.length > 0) ?
        <FadeIn>
        {epgItemCollection.map((programItem, index) => renderItem(programItem, index))}
        </FadeIn>
      :
        <FadeIn>
        <div className="epg-programlist__empty">
          <div className="container-fluid">
          { emptyComponent }
          </div>
        </div>
        </FadeIn>
    }
    </Accordion>
  );
};

EPGProgramList.propTypes = {
  emptyComponent: PropTypes.element,
  epgItemCollection: PropTypes.array,
  isLoading: PropTypes.bool,
  listHeight: PropTypes.number,
  loadingComponent: PropTypes.element,
  renderItem: PropTypes.func.isRequired
};

export default React.memo(EPGProgramList);
